import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { FileEarmarkArrowUp } from "react-bootstrap-icons";
import { FileUploader } from "react-drag-drop-files";
import Card from "../Card/Card";
import ValidationError from "../ValidationError/ValidationError";

interface CardFileInputProps {
  title: string;
  innerCard?: boolean;
  className?: string;
  name: string;
  onChange: Function;
  disabled?: boolean;
}

export default function CardFileInput(props: CardFileInputProps) {
  const fileTypes = ["APK", "GZ", "ZIP"];
  const fileMaxSize = 10; // MB
  const { t } = useTranslation();
  const [file, setFile] = useState<File | null>(null);
  const [typeError, setTypeError] = useState("");
  const [sizeError, setSizeError] = useState("");

  return (
    <Card
      title={props.title}
      innerCard={props.innerCard}
      className={props.className}
    >
      <div className="ms--075-rem ps-171-rem pt-228-rem pb-228-rem pe-096-rem">
        <FileUploader
          handleChange={(file: File) => {
            setTypeError("");
            setSizeError("");
            setFile(file);
            props.onChange(file);
          }}
          name={props.name}
          types={fileTypes}
          maxSize={fileMaxSize}
          hoverTitle={t("Drop here")}
          onTypeError={() => {
            setTypeError("File type is not supported!");
          }}
          onSizeError={() => {
            setSizeError("File is too big! Max file size:");
          }}
          children={
            <div
              className={"file-uploader-container" + (file ? "" : " invalid")}
            >
              <div className="file-uploader-content row">
                <div className="col-4 d-flex align-items-center justify-content-center">
                  <FileEarmarkArrowUp
                    className="text-gray-6"
                    size={"7.375rem"}
                  />
                </div>
                <div className="col-8">
                  <div className="row">
                    <span className="main-title text-contetn-black font-weight-600 pb-029-rem">
                      {file ? file.name : t("Select a file to upload")}
                    </span>
                  </div>
                  <div className="row">
                    <span className="sub-title pb-121-rem">
                      {file
                        ? t("Select or drop another file")
                        : t("or drag and drop it here")}
                    </span>
                  </div>
                  <div className="row">
                    <div>
                      <Button
                        variant="outline-primary"
                        disabled={props.disabled}
                      >
                        {t("Select")}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          disabled={props.disabled}
        />
        {!file && <ValidationError text="File is missing!" />}
        {typeError && (
          <ValidationError text={typeError} isAlwaysVisible={true} />
        )}
        {sizeError && (
          <ValidationError
            text={sizeError}
            additionalUntranslatedText={" " + fileMaxSize + "MB"}
            isAlwaysVisible={true}
          />
        )}
      </div>
    </Card>
  );
}
